import { useTranslation } from 'react-i18next';

export interface SpinnerProps {
  label?: string;
  size?: 'small' | 'medium' | 'large';
}

export function Spinner({ label, size = 'medium' }: SpinnerProps) {
  const { t } = useTranslation('layout');
  const text = label ?? t('spinner.loading');
  return (
    <div className={`spinner spinner--${size}`} role="status" aria-label={text}>
      <span className="spinner__ring" aria-hidden={true} />
      <span className="spinner__label">{text}</span>
    </div>
  );
}

export default Spinner;
